import { Badge } from '@roger/ui-components';

/**
 * The custody marker for a period billed from the External EMR.
 * Roger creates no billing cycles for such a period, so the Billing Manager
 * never lists it; this badge, beside the episode's status wherever the
 * episode is named, is where a biller learns why. The caller gates on
 * `billed_externally`; the badge does not gate itself.
 */
export const EXTERNALLY_BILLED_TITLE =
  'Billed from the External EMR. Roger creates no billing cycles for this period.';

export function ExternallyBilledBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant='outline'
      className={className}
      title={EXTERNALLY_BILLED_TITLE}
      data-testid='externally-billed-badge'
    >
      Billed externally
    </Badge>
  );
}
